import { useState, useEffect } from 'react'
import api from '../../utils/api'
import AdminLayout from '../../components/admin/AdminLayout'
import './Admin.css'

export default function AdminCourseCreate() {
  const [semesters, setSemesters] = useState<any[]>([])
  const [form, setForm] = useState({
    semesterId: '', title: '', description: '', instructor: '', credits: 0,
    teachingMethod: '', schedule: '', periodStart: '', periodEnd: '', capacity: '', deadline: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    loadSemesters()
  }, [])

  const loadSemesters = async () => {
    try {
      const res = await api.get('/semesters')
      setSemesters(res.data)
    } catch (err) {
      console.error('학기 로드 오류:', err)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    
    try {
      await api.post('/admin/courses', form)
      alert('강의가 등록되었습니다.')
      // 폼 초기화
      setForm({
        semesterId: '', title: '', description: '', instructor: '', credits: 0,
        teachingMethod: '', schedule: '', periodStart: '', periodEnd: '', capacity: '', deadline: ''
      })
    } catch (err: any) {
      alert(err.response?.data?.error || '강의 등록에 실패했습니다.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <AdminLayout>
      <div className="admin-page">
        <h1>강의 등록</h1>
        <p style={{ marginBottom: '2rem', color: '#666' }}>
          새로운 강의를 등록합니다. 학년도/계절을 선택한 후 강의 정보를 입력하세요.
        </p>

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="form-row">
            <label>학년도/계절: <span style={{ color: 'red' }}>*</span></label>
            <select 
              value={form.semesterId} 
              onChange={(e) => setForm({...form, semesterId: e.target.value})} 
              required
            >
              <option value="">선택하세요</option>
              {semesters.map(s => (
                <option key={s.id} value={s.id}>{s.year}년 {s.season}</option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <label>강좌명: <span style={{ color: 'red' }}>*</span></label>
            <input 
              type="text" 
              value={form.title} 
              onChange={(e) => setForm({...form, title: e.target.value})} 
              required 
              placeholder="예: 성경교리학"
            />
          </div>

          <div className="form-row">
            <label>교수명: <span style={{ color: 'red' }}>*</span></label>
            <input 
              type="text" 
              value={form.instructor} 
              onChange={(e) => setForm({...form, instructor: e.target.value})} 
              required 
              placeholder="예: 김목사"
            />
          </div>

          <div className="form-row">
            <label>학점:</label>
            <input 
              type="number" 
              value={form.credits} 
              onChange={(e) => setForm({...form, credits: parseInt(e.target.value) || 0})} 
              min="0"
              max="10"
            />
          </div>

          <div className="form-row">
            <label>수업방식:</label>
            <input 
              type="text" 
              value={form.teachingMethod} 
              onChange={(e) => setForm({...form, teachingMethod: e.target.value})} 
              placeholder="예: 대면, 온라인, 혼합"
            />
          </div>

          <div className="form-row">
            <label>시간표: <span style={{ color: 'red' }}>*</span></label>
            <input 
              type="text" 
              value={form.schedule} 
              onChange={(e) => setForm({...form, schedule: e.target.value})} 
              required 
              placeholder="예: 월수금 10:00-12:00"
            />
          </div>

          <div className="form-row">
            <label>수업기간 시작:</label>
            <input 
              type="date" 
              value={form.periodStart} 
              onChange={(e) => setForm({...form, periodStart: e.target.value})} 
              min="2020-01-01"
              max="2099-12-31"
            />
          </div>

          <div className="form-row">
            <label>수업기간 종료:</label>
            <input 
              type="date" 
              value={form.periodEnd} 
              onChange={(e) => setForm({...form, periodEnd: e.target.value})} 
              min="2020-01-01"
              max="2099-12-31"
            />
          </div>

          <div className="form-row">
            <label>정원: <span style={{ color: 'red' }}>*</span></label>
            <input 
              type="number" 
              value={form.capacity} 
              onChange={(e) => setForm({...form, capacity: e.target.value})} 
              required 
              min="1"
              placeholder="예: 30"
            />
          </div>

          <div className="form-row">
            <label>수강신청 마감일:</label>
            <input 
              type="date" 
              value={form.deadline} 
              onChange={(e) => setForm({...form, deadline: e.target.value})} 
              min="2020-01-01"
              max="2099-12-31"
            />
          </div>

          <div className="form-row">
            <label>강의 설명:</label>
            <textarea 
              value={form.description} 
              onChange={(e) => setForm({...form, description: e.target.value})} 
              placeholder="강의에 대한 상세 설명을 입력하세요"
              rows={5}
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? '등록 중...' : '강의 등록'}
            </button>
            <button 
              type="button" 
              onClick={() => setForm({
                semesterId: '', title: '', description: '', instructor: '', credits: 0,
                teachingMethod: '', schedule: '', periodStart: '', periodEnd: '', capacity: '', deadline: ''
              })}
              className="btn-secondary"
            >
              초기화
            </button>
          </div>
        </form>

        <div style={{ 
          marginTop: '2rem', 
          padding: '1rem', 
          background: '#f8f9fa', 
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <h3 style={{ marginTop: 0 }}>💡 안내</h3>
          <ul style={{ marginBottom: 0, paddingLeft: '1.5rem' }}>
            <li>필수 항목(<span style={{ color: 'red' }}>*</span>)은 반드시 입력해야 합니다.</li>
            <li>강의 등록 후 <strong>강의 목록</strong> 메뉴에서 수정 및 삭제가 가능합니다.</li>
            <li>같은 학기에 여러 강의를 등록할 수 있습니다.</li>
          </ul>
        </div>
      </div>
    </AdminLayout>
  )
}


